import { render, staticRenderFns } from "./LoaderComponent.vue?vue&type=template&id=22322ee4&scoped=true&"
import script from "./LoaderComponent.vue?vue&type=script&lang=js&"
export * from "./LoaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoaderComponent.vue?vue&type=style&index=0&id=22322ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22322ee4",
  null
  
)

export default component.exports